module.exports = __webpack_public_path__ + "img/timer-pause.ad534397.svg";